import { Component, ElementRef, ViewChild } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { ModelExampleVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/**
 * Vignette de présentation d'un modèle de chronocode pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'md-chronocode-example-tile-renderer',
  templateUrl: './md-chronocode-example-tile.renderer.html',
})
export class MdChronocodeExampleTileRenderer implements IWizItemRenderer<null, ModelExampleVO> {
  @ViewChild('mdChronocodeExampleTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: ModelExampleVO;
  public get data(): ModelExampleVO {
    return this._data;
  }
  public set data(data: ModelExampleVO) {
    this._data = data;
    this.mdTileRenderer.data = data;
    this.mdTileRenderer.showFooter = false;
  }

  /**
   * Vérification si le user a les droits de duplication
   */
  public get isDuplicateAllowed(): boolean {
    return !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.CHRONOCODE);
  }
}
